import { useState } from 'react'
import './AddPromoCode.scss'
import PromoCodeDialog from 'components/PromoCodeDialog/PromoCodeDialog.client'
import { analytics } from 'services/Analytics/Analytics'
import { useTranslation } from 'react-i18next'

function AddPromoCode({ showLabel, onSuccess, onOpen, onClose }) {
  const { t } = useTranslation()
  const [showAddPromoCodeDialog, setShowAddPromoCodeDialog] = useState(false)

  const openAddPromoCodeDialog = () => {
    setShowAddPromoCodeDialog(true)
    analytics.track('Add Promo Code Tapped', { Trigger: 'Checkout Item' })
    onOpen?.()
  }

  const closeAddPromoCodeDialog = () => {
    setShowAddPromoCodeDialog(false)
    onClose?.()
  }

  return (
    <>
      {showLabel && (
        <div className="AddPromoCode">
          <div className="separator" />
          <a onClick={openAddPromoCodeDialog}>
            {t('general.menu.add_promo_code.modal.title')}{' '}
          </a>
        </div>
      )}
      <PromoCodeDialog
        open={showAddPromoCodeDialog}
        onDismiss={closeAddPromoCodeDialog}
        onSuccess={onSuccess}
      />
    </>
  )
}

export default AddPromoCode
